<template>
  <modal @close="closeModal" ref="modal" :full-size="true">
    <template slot="header">
      <step :label="applicationLabel" :step="1">
        <span v-if="hasFormApplication" class="h-6 flex">
          <span
            class="relative h-6 flex flex-col justify-center items-center group cursor-pointer pr-2"
            @click="gotoStep(1)"
          >
            <span class="flex justify-center items-center">
              <img
                :src="
                  '/assets/imgs/software/' + form.application.slug + '/icon.png'
                "
                alt=""
                width="100%"
                height="100%"
                class="h-6 w-6 mr-3"
              />
              <span
                class="whitespace-no-wrap"
                v-text="form.application.name"
              ></span>
            </span>
            <span
              v-text="i18n.change"
              class="absolute top-0 mt-5 text-xs font-normal text-gray-500 group-hover:text-blue-700 group-hover:font-bold"
            ></span>
          </span>
        </span>
      </step>

      <step :label="releaseLabel" :step="2">
        <span
          v-if="hasFormRelease"
          class="relative h-6 flex flex-col justify-center items-center group cursor-pointer pr-2"
          @click="gotoStep(2)"
        >
          <span class="flex justify-center items-center">
            <span v-text="form.release.version"></span>
          </span>
          <span
            v-text="i18n.change"
            class="absolute top-0 mt-5 text-xs font-normal text-gray-500 group-hover:text-blue-700 group-hover:font-bold"
          ></span>
        </span>
      </step>

      <step :label="rendererLabel" :step="3">
        <span
          v-if="hasFormRenderer"
          class="relative h-6 flex flex-col justify-center items-center group cursor-pointer"
          @click="gotoStep(3)"
        >
          <span class="flex justify-center items-center">
            <img
              :src="
                '/assets/imgs/software/_renderer/' + form.renderer.slug + '.png'
              "
              :alt="form.renderer.name + ' ' + form.renderer.version"
              width="100%"
              height="100%"
              class="h-6 w-6 mr-3"
            />
            <span class="whitespace-no-wrap" v-text="form.renderer.name"></span>
            <span
              class="whitespace-no-wrap"
              v-text="form.renderer.version"
            ></span>
          </span>
          <span
            v-text="i18n.change"
            class="absolute top-0 mt-5 text-xs font-normal text-gray-500 group-hover:text-blue-700 group-hover:font-bold"
          ></span>
        </span>
      </step>

      <step :step="4">
        <div
          v-if="hasFormRenderer"
          class="h-6 flex items-center cursor-pointer hover:text-blue-700"
          @click="gotoStep(4)"
        >
          <span
            v-text="
              i18n.steps.estimation.title + ' & ' + i18n.steps.parameters.title
            "
          ></span>
        </div>
        <div v-else class="h-6 flex items-center">
          <span v-text="i18n.steps.estimation.title"></span>
        </div>
      </step>
    </template>
    <template slot="main" class="p-5">
      <div class="p-5">
        <div class="" v-if="currentStep === 1">
          <h2
            class="text-center w-full font-bold pb-5 text-xl"
            v-text="i18n.steps.application.labels.choose"
          ></h2>
          <applications
            :applications="applications"
            @application-selected="setApplication"
          ></applications>
        </div>
        <div class="" v-if="currentStep === 2">
          <ranch-button
            @click="changeApplication"
            icon="chevron-left"
            class="bg-gray-100"
            action=""
            :label="i18n.steps.application.labels.change"
          ></ranch-button>
          <h2
            class="text-center w-full font-bold pb-5 text-xl"
            v-text="i18n.steps.release.labels.choose"
          ></h2>
          <releases
            :slug="form.application.slug"
            @release-selected="setRelease"
          ></releases>
        </div>
        <div class="" v-if="currentStep === 3">
          <ranch-button
            @click="changeRelease"
            icon="chevron-left"
            class="bg-gray-100"
            action=""
            :label="i18n.steps.release.labels.change"
          ></ranch-button>
          <h2
            class="text-center w-full font-bold pb-5 text-xl"
            v-text="i18n.steps.renderer.labels.choose"
          ></h2>
          <renderers
            :release-id="form.release.id"
            @renderer-selected="setRenderer"
          ></renderers>
        </div>
        <div class="" v-show="currentStep === 4">
          <create-project
            v-if="form.renderer"
            :i18n="{
              estimation: i18n.steps.estimation.i18n,
              submit: i18n.steps.parameters,
            }"
            :renderer="form.renderer"
            :application-slug="form.application.slug"
            :missing-frames="missingFrames"
            @project-created="setProject"
          >
            <template slot="goback">
              <div>
                <ranch-button
                  @click="changeRenderer"
                  icon="chevron-left"
                  class="bg-gray-100"
                  action=""
                  :label="i18n.steps.renderer.labels.change"
                ></ranch-button>
              </div>
            </template>
          </create-project>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { flash } from "@/boot/functions";

import Modal from "../../Design/Modal";
import Step from "../../Design/Stepper/Step";
import Applications from "../NewProject/Applications";
import Releases from "../NewProject/Releases";
import Renderers from "../NewProject/Renderers";
import CreateProject from "../NewProject/Create/CreateProject";

export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
    copyMode: {
      type: Boolean,
      default: false,
      required: false,
    },
    projectToCopy: {
      type: Object,
      default: undefined,
      required: false,
    },
    missingFrames: {
      type: String,
      default: "",
      required: false,
    },
  },
  components: {
    Modal,
    Step,
    Applications,
    Releases,
    Renderers,
    CreateProject,
  },
  data() {
    return {
      currentStep: this.step,
      form: {
        application: undefined,
        release: undefined,
        renderer: undefined,
        parameters: undefined,
        priority: undefined,
      },
      estimation: {},
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    nextStep() {
      if (this.currentStep < 6) {
        this.currentStep += 1;
      }
    },

    gotoStep(step) {
      if (step === 1) {
        this.form.application = undefined;
        this.form.release = undefined;
        this.form.renderer = undefined;
      }

      if (step === 2) {
        this.form.release = undefined;
        this.form.renderer = undefined;
      }

      if (step === 3) {
        this.form.renderer = undefined;
      }

      this.currentStep = step;
    },

    gotoUpload(id) {
      this.$router.push({
        name: "project.upload",
        params: this.dashboardRouteParams(id),
      });
    },
    gotoPriority(id) {
      this.$router.push({
        name: "project.priority",
        params: this.dashboardRouteParams(id),
      });
    },

    dashboardRouteParams(id) {
      return {
        id,
        type: this.$route.params.type || "projects",
        locale: this.$route.params.locale,
      };
    },

    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep -= 1;
      }
    },

    setApplication(application) {
      this.form.application = application;
      this.nextStep();
    },

    changeApplication() {
      this.form.application = undefined;
      this.previousStep();
    },

    setRelease(release) {
      this.form.release = release;
      this.nextStep();
    },

    changeRelease() {
      this.form.release = undefined;
      this.previousStep();
    },

    setRenderer(renderer) {
      this.form.renderer = renderer;
      this.nextStep();
    },

    changeRenderer() {
      this.form.renderer = undefined;
      this.previousStep();
    },

    setProject(project) {
      this.$store.commit("dashboard/addProject", project);
      this.$store.commit("app/setLastRenderer", {
        application: project.application,
      });

      flash(
        this.i18n.steps.parameters.success.replace(":id", project.id),
        "success"
      );

      if (project.priority.id > 0) {
        this.gotoUpload(project.id);
      } else {
        this.gotoPriority(project.id);
      }
      this.closeModal();
    },
  },
  computed: {
    i18n() {
      return this.$store.state.dashboard.i18n.new_project;
    },
    applicationLabel() {
      if (this.hasFormApplication) {
        return "";
      }

      return this.i18n.steps.application.title;
    },

    releaseLabel() {
      if (this.hasFormRelease) {
        return "";
      }

      return this.i18n.steps.release.title;
    },

    rendererLabel() {
      if (this.hasFormRenderer) {
        return "";
      }

      return this.i18n.steps.renderer.title;
    },

    lastRenderer() {
      return this.$store.state.app.lastRenderer;
    },

    hasLastRenderer() {
      return this.lastRenderer !== undefined && this.lastRenderer !== null;
    },

    hasFormApplication() {
      return this.form.application !== undefined;
    },

    hasFormRelease() {
      return this.form.release !== undefined;
    },

    hasFormRenderer() {
      return this.form.renderer !== undefined;
    },

    applications() {
      return this.$store.state.app.applications;
    },
  },
  mounted() {
    if (this.copyMode && this.projectToCopy !== undefined) {
      this.form.application = {
        name: this.projectToCopy.application.name,
        slug: this.projectToCopy.application.slug,
      };
      this.form.release = this.projectToCopy.application.release;
      this.form.renderer = this.projectToCopy.application.renderer;
    } else {
      if (this.hasLastRenderer) {
        this.form.application = {
          name: this.lastRenderer.application.name,
          slug: this.lastRenderer.application.slug,
        };
        this.form.release = this.lastRenderer.application.release;
        this.form.renderer = this.lastRenderer.application.renderer;
      }
    }
  },
};
</script>
